import { render, staticRenderFns } from "./UiModals.vue?vue&type=template&id=2aa7caf6&"
import script from "./UiModals.vue?vue&type=script&lang=js&"
export * from "./UiModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports